<template>
	<span>
		<JonInfo v-if="!inContacting || waitingForAcceptance">
			<template #message>
				<div class="d-flex align-items-center flex-column flex-md-row">
					<div class="flex-grow-1 mr-2">
						<div class="font-weight-bold">Klingt gut für dich?</div>
						<div v-if="waitingForAcceptance">Dann akzeptiere die Anfrage des Kandidaten so schnell wie möglich!</div>
						<div v-else>Dann melde dich schnell bei dem Kandidaten!</div>
					</div>
					<div class="mt-4 mt-md-0">
						<Button
							v-if="waitingForAcceptance"
							text="Kontaktanfrage annehmen"
							icon="checkmark"
							@click="onAcceptRequest"
						/>
						<Button
							v-else
							icon="checkmark"
							text="Jetzt kontaktieren"
							:primary="true"
							@click="onClick"
						/>
					</div>
				</div>
			</template>
		</JonInfo>
	</span>
</template>

<script>
import Button from "@/vue/common/Button";
import {mapActions} from "vuex";
import {isDefined} from "@/helper/Value";
import Add from "@/api/event/Add";
import {PORTAL_CUSTOMER_CONTACTING_CLICK} from "@/helper/event/Category";
import JonInfo from "@/vue/common/JonInfo.vue";

export default {

	components: {
		JonInfo,
		Button,
	},

	props: {
		jobId: {
			type: String,
			required: true,
		},
		jobProfileId: {
			type: String,
			required: true,
		},
		applicant: {
			type: Object,
			required: true,
		},
		initialInContacting: {
			type: Boolean,
			required: true,
		},
		waitingForAcceptanceMessage: {
			type: Object,
			required: false,
		}
	},

	data ()
	{
		return {
			inContacting: this.initialInContacting,
			waitingForAcceptance: isDefined(this.waitingForAcceptanceMessage),
		};
	},

	methods: {
		...mapActions('communication/contactApplicant', {
			openFan: 'show'
		}),
		...mapActions('communication/conversation/messages/reply', {
			openReplyFan: 'show',
		}),
		async onAcceptRequest ()
		{
			await this.openReplyFan({
				title: 'Kontaktanfrage annehmen',
				message: this.waitingForAcceptanceMessage,
				onProcessed: () =>
				{
					this.inContacting = true;
					this.waitingForAcceptance = false;

					this.$emit('contacted');
				}
			});
		},
		onClick ()
		{
			new Add()
				.setCategory(PORTAL_CUSTOMER_CONTACTING_CLICK)
				.setJob(this.jobId)
				.setJobProfile(this.jobProfileId)
				.call();

			this.openFan({
				jobId: this.jobId,
				jobProfileId: this.jobProfileId,
				applicant: this.applicant,
				onContacted: () =>
				{
					this.inContacting = true;
					this.waitingForAcceptance = false;

					this.$emit('contacted');
				}
			});
		},
		onContacted ()
		{
			this.inContacting = true;
		}
	}
}
</script>
